<span [style.color]="color ? color : 'inherit'">
  {{ value }}
</span>